import {fitVids} from './fitvids.js';
import {gallery} from './gallery.js';

fitVids();
gallery();
